import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../utils";

// Async thunk — clear chat history
export const clearChatHistory = createAsyncThunk('clearChatHistory', async () => {
    try {
        const res = await axios.post(process.env.REACT_APP_CHAT_URL + 'history/clear', {}, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: SessionManager.getSession("user_token"),
            },
        });

        return res;
    } catch (error) {
        return error.response;
    }
});

const clearChatHistorySlice = createSlice({
    name: "clearChatHistory",
    initialState: {
        clearingChat: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Clear chat history cases
            .addCase(clearChatHistory.pending, (state) => {
                state.clearingChat = true;
                state.error = null;
            })
            .addCase(clearChatHistory.fulfilled, (state) => {
                state.clearingChat = false;
                state.error = null;
            })
            .addCase(clearChatHistory.rejected, (state, action) => {
                state.clearingChat = false;
                state.error = action.payload?.message || action.error?.message || 'Failed to clear chat history.';
            });
    },
});

export default clearChatHistorySlice.reducer;

